import { NavLink } from 'react-router-dom'
import styled from '../../config/theme'
import Button from '../Button'

const Container = styled.header<{ right: boolean }>`
  background: white;
  border-bottom: 1px solid ${props => props.theme.color.lightGray};

  position: sticky;
  height: 72px;
  width: 100%;

  z-index: ${props => props.theme.zIndex.header};

  top: 0;
  left: 0;

  display: flex;
  justify-content: ${props => props.right ? 'flex-end' : 'space-between'};
  align-items: stretch;

  padding: 0 10px;

  + * {
    // margin-top: 72px;
  }
`

const Logo = styled(NavLink)`
  display: flex;
  align-items: center;
  color: ${props => props.theme.color.darkBlue};
  font-size: 2em;
  text-decoration: none;
  font-weight: bold;
  line-height: 2.3em;
  &::before {
    content: " ";
    display: block;
    background: url('/favicon.ico');
    background-size: 63px 64px;
    width: 63px;
    height: 64px;
    margin-right: 15px;
  }
`

const LogoWithoutImage = styled(NavLink)`
  display: flex;
  align-items: center;
  color: ${props => props.theme.color.darkBlue};
  font-size: 2em;
  text-decoration: none;
  font-weight: bold;
  line-height: 2.3em;
  &::before {
    content: " ";
    display: block;
    background-size: 63px 64px;
    width: auto;
    height: 64px;
    margin-right: 15px;
  }
`
const OutherMenuContent = styled.div`
  margin-right: 50px;
  margin-top: auto;
  margin-bottom: auto;
  ${props => props && `
    @media screen and (min-width: ${props.theme.mediaQueries.menu}) {
      display: none
    }`}
`
const InMenuContent = styled.div`
  ${props => props && `
    @media screen and (max-width: ${props.theme.mediaQueries.menu}) {
      display: none
    }`}
`

const Actions = styled.div<{ open: boolean, noBurgerOnMobile: boolean }>`
  display: flex;
  align-items: center;

  > * {
    margin: 0 5px;
  }

  ${props => !props.noBurgerOnMobile && `
    @media screen and (max-width: ${props.theme.mediaQueries.menu}) {
      position: fixed;
      top: 0;
      left: 0;
      // display: none;
      height: 100vh;
      width: 100vw;
      z-index: 2;
      background: white;

      transform: translateX(100%);
      transition: transform .2s;

      ${props.open && `
        // display: flex;
        transform: translateX(0);
        transition: transform .2s;
      `}

      flex-direction: column;
      justify-content: center;

      // > * {
      //   margin: 20px 0;
      // }

      > button {
        top: 0;
        right: 10px;
      }
    }
  `}
`

const MobileToggle = styled(Button) <{ noBurgerOnMobile: boolean }>`
  position: absolute;
  display: none;

  right: 0;
  margin: 0;
  height: 72px;
  z-index: 1;

  @media screen and (max-width: ${props => props.theme.mediaQueries.menu}) {
    display: ${props => props.noBurgerOnMobile ? 'none' : 'unset'};
  }
`

export { MobileToggle, Container, Logo, LogoWithoutImage, Actions, OutherMenuContent, InMenuContent }

